import type { WorkQueueItemType } from "@/features/work-queue/model/work-queue.types"

export const WORK_QUEUE_ROOT_KEY = ["work-queue"] as const

export const workQueueQueryKeys = {
  root: WORK_QUEUE_ROOT_KEY,
  summary: (workspaceId: string | null | undefined, userId: string | null | undefined) =>
    [...WORK_QUEUE_ROOT_KEY, "summary", workspaceId ?? "__none__", userId ?? "__user__"] as const,
  /** One branch's slice of the summary (the branch home dashboard's "to validate" tile). */
  branchSummary: (
    workspaceId: string | null | undefined,
    userId: string | null | undefined,
    branchId: string | null | undefined,
  ) =>
    [...WORK_QUEUE_ROOT_KEY, "summary", workspaceId ?? "__none__", userId ?? "__user__", "branch", branchId ?? "__none__"] as const,
  /** Every page of every tab of one workspace's queue: what a decision taken from the queue invalidates. */
  workspaceItems: (workspaceId: string | null | undefined) => [...WORK_QUEUE_ROOT_KEY, "items", workspaceId ?? "__none__"] as const,
  /** Every summary (whole queue and per branch) of one workspace. */
  workspaceSummaries: (workspaceId: string | null | undefined) =>
    [...WORK_QUEUE_ROOT_KEY, "summary", workspaceId ?? "__none__"] as const,
  /** One page of one tab. The queue is per user: each resolver authorizes the caller, so the user is in the key. */
  items: (
    workspaceId: string | null | undefined,
    userId: string | null | undefined,
    type: WorkQueueItemType | null,
    paging: { page: number; limit: number },
  ) =>
    [
      ...WORK_QUEUE_ROOT_KEY,
      "items",
      workspaceId ?? "__none__",
      userId ?? "__user__",
      type ?? "__all__",
      { page: paging.page, limit: paging.limit },
    ] as const,
}
